import { IonCardContent, IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import { useState } from 'react';

import { StatusDotGroup } from '@/pages/ReportV2/components/Fields/Fields';

import { CardHeader } from '@/components/CardHeader/cardHeader';
// Styles
import styles from '@/components/Cards/MobilityStatusCard.module.css';
import { ReportModal } from '@/components/Modal/ReportModal';

// Components
import { Card } from '.';

type AttractorCardProps = {
  title: string;
  info: React.ReactNode;
  img: string;
  romRow: number[];
  statusRow: number[];
};

/** Card in the analysis page to show the avatar and attractor field
 * @param img - The avatar image
 * @param labels - Attractor labels for the status field, tuple of (Left, Right) values
 */
export const MobilityStatusCard = ({ title, info, img, romRow, statusRow }: AttractorCardProps) => {
  const [showModal, setShowModal] = useState({ show: false });

  return (
    <>
      <ReportModal
        header={`${title} Mobility`}
        isOpen={showModal.show}
        onDidDismiss={() => setShowModal({ show: false })}
        setShowInfo={() => setShowModal({ show: false })}>
        {info}
      </ReportModal>

      <Card style={{ height: 'fit-content', margin: 0 }}>
        <CardHeader info={true} setShowInfo={setShowModal} title={title} />
        <IonCardContent className={styles.cardContent}>
          <IonGrid class='ion-no-padding' fixed>
            <IonRow className='full_width ion-justify-content-center'>
              <IonCol>
                <IonImg class={styles.avatar} src={img} />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol style={{ marginRight: '4px' }}>
                <StatusDotGroup name='Left' status={statusRow[0]} value={romRow[0].toFixed(0) + '°'} />
              </IonCol>
              <span style={{ width: '1px', backgroundColor: '#e0e0e0' }} />
              <IonCol style={{ marginLeft: '4px' }}>
                <StatusDotGroup name='Right' status={statusRow[1]} value={romRow[1].toFixed(0) + '°'} />
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCardContent>
      </Card>
    </>
  );
};
